import BMapLib from 'counselor-mobile-ui/utils/feature/map/BMapUtils'
import {
  checkAssignVersion,
  getCpdailyVersion,
} from 'counselor-sdk/lib/utils/platform'

// import { Dialog } from 'vant'
import { isIOS } from 'counselor-mobile-ui/utils/feature/platform'

export const getUrlParams = () => {
  const params = {}
  let search = window.location.search && window.location.search.substr(1)

  search = window.location.search.substr(1).replace(/&/g, ',')
    .split(',')

  search.forEach((el) => {
    const kv = el.split('=')

    if (kv.length === 2) {
      params[kv[0]] = kv[1]
    }
  })

  return params
}

export const isOverflown = (element) => {
  if (!element) {
    return false
  }

  return (
    element.scrollHeight - element.clientHeight > 1 || // 苹果会有 1px 的误差，暂不知为何
      element.scrollWidth > element.clientWidth
  )
}

const getDistance = (p0, p1) => {
  return BMapLib.GeoUtils.getDistance(new BMap.Point(p0.lng, p0.lat), new BMap.Point(p1.lng, p1.lat))
}

export const checkLocation = (scopes, locInfo) => {
  if (!locInfo || !scopes) {
    return -1
  }

  let minDistance = 0

  for (let i = 0, len = scopes.length; i < len; i++) {
    const scope = scopes[i]
    const distance = getDistance({
      lng: locInfo.longitude || locInfo.lng,
      lat: locInfo.latitude || locInfo.lat,
    }, {
      lng: scope.longitude,
      lat: scope.latitude,
    })

    if (distance <= scope.radius) {
      return 0
    }

    if (minDistance === 0) {
      minDistance = distance
    } else {
      minDistance = Math.min(distance, minDistance)
    }
  }

  return minDistance
}

export function formatDate (date, fmt) {
  const currentDate = new Date(date)
  const o = {
    'M+': currentDate.getMonth() + 1, // 月份
    'd+': currentDate.getDate(), // 日
    'h+': currentDate.getHours(), // 小时
    'm+': currentDate.getMinutes(), // 分
    's+': currentDate.getSeconds(), // 秒
    'q+': Math.floor((currentDate.getMonth() + 3) / 3), // 季度
    S: currentDate.getMilliseconds(), // 毫秒
  }

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (`${currentDate.getFullYear()}`).substr(4 - RegExp.$1.length))
  }

  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)))
    }
  }

  return fmt
}

// 校验是否开启外存储
export async function checkStoragePermission () {
  // ios不需要校验
  if (isIOS) {
    return true
  }

  // 不在今日校园中, 直接返回
  if (!window.mamp) {
    return true
  }

  const versions = [
    '10.0.0',
    '10.0.1',
    '10.0.2',
    '10.0.3',
    '10.0.4',
    '10.0.5',
    '10.0.6',
  ]

  const currentVer = getCpdailyVersion()

  if (versions.includes(currentVer)) {
    return true
  }

  // // 9.3.4及以上版本使用sdk校验
  if (checkAssignVersion('9.3.4')) {
    // MARK: 9.3.4版本校验
    const authorityStatus = window.mamp?.systemAbility?.authorityStatus

    // 没有这个方法就直接返回了
    // 如果是在9.3.4及以上版本,肯定会有这个方法的, 但是...
    if (!authorityStatus) {
      return true
    }

    // 检查外存储权限
    // -1: 尚未询问过用户
    // 0: 没有权限
    // 1: 有权限
    const auth = await new Promise((resolve) => authorityStatus('EXTERNAL_STORAGE', resolve))

    // 如果没有权限, 就去请求权限
    if (auth !== 1) {
      const requestAuthority = window.mamp?.systemAbility?.requestAuthority

      if (!requestAuthority) {
        return true
      }

      // true: 用户同意
      // false: 用户拒绝
      const res = await new Promise((resolve) => requestAuthority(
        'EXTERNAL_STORAGE',
        `您需要点击下方按钮为今日校园授取存储权限，授权完成后，可继续提交或使用。当前今日校园版本号${getCpdailyVersion()}`,
        resolve
      ))

      return res
    }
  }

  return true

  // 9.3.3以下的版本不需要校验
  // const vers = getCpdailyVersion()?.split('.')
  //   ?.slice(0, 3)
  //   .join('.')

  // if (vers !== '9.3.3') {
  //   return true
  // }

  // try {
  //   return await Dialog.confirm({
  //     title: '授权申请',
  //     message: '您需要前往手机设置-应用权限中开启今日校园的存储权限，开启后您可继续提交或使用。当前今日校园版本号9.3.3',
  //     confirmButtonText: '已授权',
  //     confirmButtonColor: '#3399ff',
  //   })
  // } catch (e) {
  //   // NOOP
  // }
}
